import * as React from 'react';

import CourseHomeText from 'bundles/degree-home/components/course-section/CourseHomeText';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

import 'css!./__styl__/CourseHeader';

type Props = {
  name: string;
  link: string;
  degreeId: string;
};

const CourseHeader = ({ name, link, degreeId }: Props) => {
  const maxLength = 80;
  let trimmedName = name.substr(0, maxLength);
  trimmedName = trimmedName.substr(0, Math.min(trimmedName.length, trimmedName.lastIndexOf(' ')));
  const showTrimmedName = name.length > maxLength;

  return (
    <TrackedA
      href={link}
      className="rc-CourseHeader nostyle horizontal-box align-items-spacebetween p-x-2 p-y-1 heading"
      trackingName="nav_item"
    >
      <span className="bold">{showTrimmedName ? `${trimmedName}...` : name}</span>
      <span className="bt3-visible-xs arrow">→</span>
      <div className="horizontal-box bt3-hidden-xs">
        <CourseHomeText degreeId={degreeId} />
        <span className="arrow">→</span>
      </div>
    </TrackedA>
  );
};

export default CourseHeader;
